<div class="tabs">
  <div class="tab">
    <button (click)="tabs.active = 'tecnic'" [ngClass]="{ active: tabs.active === 'tecnic' }">Tecnic</button>
  </div>
  <div class="tab">
    <button (click)="tabs.active = 'plugins'" [ngClass]="{ active: tabs.active === 'plugins' }">Plugins</button>
  </div>
  <div class="tab">
    <button (click)="tabs.active = 'viewer'" [ngClass]="{ active: tabs.active === 'viewer' }">Viewer</button>
  </div>
</div>

<div class="tabs-content">
  <app-version [hidden]="tabs.active !== 'tecnic'" #version></app-version>

  <app-sbeditor-tool-indoor
    *ngIf="indoorTool"
    [hidden]="tabs.active !== 'plugins'"
    #indoor
    (exportTool)="getTool($event, 'indoor')"></app-sbeditor-tool-indoor>
  <app-sbeditor-tool-navigation
    *ngIf="navTool"
    [hidden]="tabs.active !== 'plugins'"
    #navigation
    (exportTool)="getTool($event, 'navigation')"></app-sbeditor-tool-navigation>

  <app-sbeditor-tool-copylink
    *ngIf="cpTool"
    [hidden]="tabs.active !== 'viewer'"
    #copylink
    (exportTool)="getTool($event, 'copylink')"></app-sbeditor-tool-copylink>
  <app-sbeditor-tool-fullscreen
    *ngIf="fsTool"
    [hidden]="tabs.active !== 'viewer'"
    #fullscreen
    (exportTool)="getTool($event, 'fullscreen')"></app-sbeditor-tool-fullscreen>
  <app-sbeditor-tool-vr
    *ngIf="vrTool"
    [hidden]="tabs.active !== 'viewer'"
    #vr
    (exportTool)="getTool($event, 'vr')"></app-sbeditor-tool-vr>
</div>

<div class="tabs-bottom">
  <button class="btn-secondary-action" (click)="save()">Aplicar cambios</button>
</div>
